import { useEffect, useState } from "react";

import { trpc } from "../trpc";
import { resolveScopeHint } from "./scope-hints";

export interface CredentialRow {
  slug: string;
  name: string;
  shortName: string;
  meta: string;
  /** Industry group slug (see CATEGORIES in @passfirst/types). */
  category: string;
  /** True when at least one non-FEDERAL jurisdiction is registered. */
  hasJurisdictions: boolean;
}

interface UseCredentialsReturn {
  rows: CredentialRow[] | null;
  error: string | null;
}

// Wraps trpc.vertical.listLive + builds the welcome-row meta strings
// (full name + scope hint). Federal-only verticals skip the state
// picker — hasJurisdictions tells the orchestrator which route to push.
export function useCredentials(): UseCredentialsReturn {
  const [rows, setRows] = useState<CredentialRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const raw = await trpc.vertical.listLive.query();
        const list: CredentialRow[] = raw.map((r) => {
          const stateCount = r.jurisdictions.filter(
            (j) => j.code !== "FEDERAL",
          ).length;
          return {
            slug: r.slug,
            name: r.name,
            shortName: r.shortName,
            category: r.category,
            hasJurisdictions: stateCount > 0,
            meta: resolveScopeHint({
              slug: r.slug,
              shortName: r.shortName,
              stateCount,
            }),
          };
        });
        setRows(list);
      } catch (err) {
        setError(err instanceof Error ? err.message : "failed to load");
      }
    })();
  }, []);

  return { rows, error };
}
